import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  ViewChild,
} from '@angular/core';
import { Environment, URL_REGEX } from '@t-llevo/util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'commonui-preload-img',
  templateUrl: './preload-img.component.html',
  styleUrl: './preload-img.component.css',
  animations: [
    trigger('imageAnimation', [
      state(
        'show-image',
        style({
          opacity: '1',
          display: 'inline',
        })
      ),
      state(
        'hide-image',
        style({
          opacity: '0',
          display: 'none',
        })
      ),
      transition('show-image <=> hide-image', animate('1000ms ease-in')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PreloadImgComponent{
  imageCtrl = 'hide-image';
  contentCtrl = 'show-image';
  onErrorCount = 1;
  @Input() urlImg = '';
  @Input() alternativeImg = 'assets/no-photo.svg';
  @Input() elemClass = 'default-element';
  @Input() imgClass = 'default-image';
  @Input() containerClass = 'default-container';
  @Input() containerHeight = 48;
  @Input() containerWidth = 48;
  @Input() imageHeight = 48;
  @Input() imageWidth = 48;
  @Input() unit = 'px';
  @Input() ratio = 1;
  @ViewChild('lImage') lImage!: ElementRef<HTMLImageElement>;

  constructor(@Inject(Environment) private env: Environment) {}

  get imageWidthUnit(): string {
    return `${this.imageWidth}${this.unit}`;
  }

  get calcImageHeight(): number {
    if (this.ratio) {
      return this.imageWidth / this.ratio;
    }
    return this.imageWidth;
  }

  get imageHeightUnit(): string {
    return `${this.calcImageHeight}${this.unit}`;
  }

  get containerWidthUnit(): string {
    return `${this.containerWidth}${this.unit}`;
  }

  get calcContainerHeight(): number {
    if (this.ratio) {
      return this.containerWidth / this.ratio;
    }
    return this.containerWidth;
  }

  get containerHeightUnit(): string {
    return `${this.calcContainerHeight}${this.unit}`;
  }

  loadImage(): void {
    const regexExp = new RegExp(URL_REGEX);
    if (this.urlImg && !this.urlImg.includes('data:image/png;base64')) {
      if (!regexExp.test(this.urlImg)) {
        this.urlImg = `${this.env.apiUrl}/${this.urlImg}`;
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onLoadImg(e: Event): void {
    this.imageCtrl = 'show-image';
    this.contentCtrl = 'hide-image';
  }

  onErrorImg(): void {
    if (this.onErrorCount === 1) {
      this.lImage.nativeElement.src = this.alternativeImg;
      this.imageCtrl = 'show-image';
      this.contentCtrl = 'hide-image';
    }
    this.onErrorCount++;
  }
}
